module.exports = __webpack_public_path__ + "img/renzhengshibai.2c53d8df.png";